import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import View from './view';

export default connect(controller)(View);
